// The checkout captcha widget sits below #cart-payment, and on the multi-product cart outside the
// form, so its token is not always in the form's FormData. These helpers bridge it into every
// checkout submit. See checkout_captcha_controller.js.

const widgetElement = () =>
  document.querySelector('[data-checkout-captcha-widget-id]')

export const appendCheckoutCaptchaToken = (formData) => {
  const element = widgetElement()
  if (!element || !window.grecaptcha) return formData

  const token = window.grecaptcha.getResponse(
    Number(element.dataset.checkoutCaptchaWidgetId)
  )
  if (token) formData.set('g-recaptcha-response', token)
  return formData
}

// A token can be verified only once, so any failed submit needs a fresh solve.
export const resetCheckoutCaptcha = () => {
  const element = widgetElement()
  if (!element || !window.grecaptcha) return

  window.grecaptcha.reset(Number(element.dataset.checkoutCaptchaWidgetId))
}
